import { useMemo, useState } from 'react'

import { useFragment } from '@apollo/client'
import { Box } from '@factorialco/deprecated-design-system'
import { RichTextDisplay, Tabs } from '@factorialco/f0-react/dist/experimental'
import { ManualTaskContentFragmentDoc } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Attachments from 'modules/inbox_tasks/components/Attachments'

import CommentsTab from 'modules/inbox_tasks/tasks/manual/Comments'
import { StepActionContentComponent } from 'modules/inbox_tasks/tasks/employeeLifecycleStepAction/helpers'

const TABS = [
  {
    id: 'details',
    label: () => i18n.t('common.details'),
  },
  {
    id: 'comments',
    label: () => i18n.t('comments.title.default'),
  },
]

const TABS_WRAPPER_STYLE = {
  margin: '0 -24px',
}

const BasicTaskContent: StepActionContentComponent = ({ taskId }) => {
  const { data: taskInfo } = useFragment({
    fragment: ManualTaskContentFragmentDoc,
    fragmentName: 'ManualTaskContent',
    from: {
      __typename: 'TasksInboxTask',
      id: taskId,
    },
    optimistic: false,
  })

  const tabs = useMemo(
    () =>
      TABS.map((tab) => ({
        ...tab,
        label: tab.label(),
      })),
    []
  )

  const files = useMemo(
    () =>
      taskInfo?.attachmentsConnection?.nodes
        ?.map(
          (node) =>
            node &&
            node.filename &&
            node.url && {
              name: node.filename,
              type: node.contentType,
              url: node.url,
            }
        )
        .filter(Boolean),
    [taskInfo]
  )

  const [activeTabId, setActiveTabId] = useState<string | undefined>(tabs?.[0]?.id)

  if (!taskInfo) return null

  return (
    <Box flexDirection="column" gap="s16" overflowX="hidden">
      <Box style={TABS_WRAPPER_STYLE}>
        <Tabs tabs={tabs} activeTabId={activeTabId} setActiveTabId={setActiveTabId} />
      </Box>
      <Box width="full" className={activeTabId !== 'details' ? 'hidden' : undefined}>
        <Box flexDirection="column" gap="s32">
          {taskInfo.content ? <RichTextDisplay content={taskInfo.content} /> : null}
          {!!files?.length && (
            <Box flexDirection="column" gap="s16">
              <Attachments files={files} />
            </Box>
          )}
        </Box>
      </Box>
      <Box width="full" className={activeTabId !== 'comments' ? 'hidden' : undefined}>
        <CommentsTab taskId={taskId} />
      </Box>
    </Box>
  )
}

export default BasicTaskContent
